<template>
  <el-table-column
    prop="customer_postal_code"
    sortable="custom"
    label="Szállítási cím"
    show-overflow-tooltip
    min-width="230"
  >
    <template slot-scope="scope">
      {{ scope.row.customer_postal_code }} {{ scope.row.customer_city }} {{ scope.row.customer_address }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'customer_postal_code',
};
</script>
